package com.klantenstop.web.data.models.dto.requests

import kotlinx.serialization.Serializable

@Serializable
data class ForgotPasswordDto(
    val email: String
)

